import React, {useEffect, useRef, useState} from 'react';
import {Col, DatePicker, Form, Input, message, Row} from 'antd';
import {ProForm, ProFormInstance} from '@ant-design/pro-form';
import {WdiCardTitle, WdiModalAppResult} from '@/components/WdiControls';
import {FormPageProps} from '@/components/WdiBus/FormPage';
import {FileUploadUtility, WdiFileUpload} from '@/components/WdiControls/WdiFileUpload';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiSelect, WdiSelectFormat} from '@/components/WdiControls/WdiSelect';
import {ApplyFooter, ApplyFooterType} from '@/components/WdiBus/ApplyFooter';
import {ResponseStatus} from '@/utils/request';
import {FormSaMkt, FormSaMktAllocateCc, FormSaMktAllocateMonth, FormSaMktDetail} from '@/services/mkt/sa';
import moment from 'moment';
import {WarningInfoAppProps} from '@/components/WdiBus/PanelForWarning';
import {BOHQ} from '@/services/mdm/bohq';
import DataStore from '@/components/GridWidget/DataStore';
import {Enum} from '@/enums/system';
import {addAllocateAmount, initApplyPageContext, ViewEntityProps} from "@/pages/mkt/sa/components/data";
import SaMktWarningInfoApp from "@/pages/mkt/sa/components/WarningInformation";
import FormSaMktDetailsForApplyPanel from "@/pages/mkt/sa/MktApply/components/Detail";
import FormSaMktDetailAllocateMonthApp from "@/pages/mkt/sa/MktApply/components/DetailAllocate";
import FormSaMktDetailAllocateCcApp from "@/pages/mkt/sa/MktApply/components/DetailAllocateBo";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";


const {RangePicker} = DatePicker;

const getPageResult = (values: any, viewEntity: ViewEntityProps, statusId: number, dataSource: any[], formSaMktAllocateMonths: any[], formSaMktAllocateCcs: any[]) => {
  const result: WdiModalAppResult = {code: ResponseStatus.UNKNOWN};

  const {activityDate, fileInfo, ...entity} = values;

  const req: {
    form: any;
    formSaMkt: any;
    formSaMktDetails: any[];
    formSaMktAllocateMonths: any[];
    formSaMktAllocateCcs: any[]
  } = {
    form: {
      statusId: statusId,
      pageTypeId: viewEntity.pageTypeId,
      formTypeId: viewEntity.formTypeId,
      userId: viewEntity?.userId,
      positionId: viewEntity?.positionId,
    },
    formSaMkt: {},
    formSaMktDetails: [],
    formSaMktAllocateMonths: [],
    formSaMktAllocateCcs: []
  };

  if (viewEntity.formId) {
    //草稿打开
    req.form.formId = viewEntity.formId;
  } else if (viewEntity.relatedFormId) {
    if (viewEntity.relationType === Enum.FormRelationType.REJECTED
      || viewEntity.relationType === Enum.FormRelationType.MODIFIED) {
      // 退回待修改,修改单据
      req.form.relatedFormId = viewEntity.relatedFormId;
      req.form.relationType = viewEntity.relationType;
    }
    req.form.formId = 0;
  }

  if (activityDate && activityDate.length == 2) {
    entity.activityStartDate = moment(activityDate[0]).format("YYYY-MM-DD");
    entity.activityEndDate = moment(activityDate[1]).format("YYYY-MM-DD");
  } else {
    result.message = "无效的活动期间";
    return result;
  }
  if (FileUploadUtility.isUploading(fileInfo)) {
    result.message = '附件正在上传中!';
    return result;
  }
  if (FileUploadUtility.isError(fileInfo)) {
    result.message = '附件存在错误文件!';
    return result;
  }
  const info = FileUploadUtility.serialize(fileInfo);
  entity.fileName = info?.names;
  entity.filePath = info?.urls;
  entity.statusId = statusId;
  entity.bohqId = WdiSelectFormat.getvalue(entity.bohqId);
  req.formSaMkt = entity;
  if (dataSource && dataSource.length) {
    dataSource.forEach((item, itemIndex) => {
      item.rowNumber = itemIndex + 1;
    });
  } else {
    result.message = "请填写费用明细!";
    return result;
  }
  if (formSaMktAllocateMonths.length < 1) {
    result.message = '请填写月分摊信息！'
    return result;
  }
  if (formSaMktAllocateCcs.length < 1) {
    result.message = '请填写使用部门分摊信息！'
    return result;
  }


  req.formSaMktDetails = dataSource;
  req.formSaMktAllocateMonths = formSaMktAllocateMonths;
  req.formSaMktAllocateCcs = formSaMktAllocateCcs;
  result.data = req;
  result.code = ResponseStatus.SUCCESS;
  return result;
};

const MktApplyApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [entity, setEntity] = useState<ViewEntityProps>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [formSaMktAllocateMonths, setFormSaMktAllocateMonths] = useState<any[]>([]);
  const [formSaMktAllocateCcs, setFormSaMktAllocateCcs] = useState<any[]>([]);
  const [warningSettings, setWarningSettings] = useState<WarningInfoAppProps>({visible: false});
  const [formSaMktDate, setFormSaMktDate] = useState<{ activityStartDate?: Date, activityEndDate?: Date }>();
  const [editorRef,setEditorRef] = useState<any>();

  const onDetailsChange = (data: any) => {
    setDataSource(data);
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApplyPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;
        if (viewEntity.formSaMkt) {
          formRef.current?.setFieldsValue({
            activityName: viewEntity.formSaMkt?.activityName,
            activityDate: [moment(viewEntity.formSaMkt?.activityStartDate), moment(viewEntity.formSaMkt?.activityEndDate)],
            bohqId: viewEntity.formSaMkt.bohqId,
            remark: viewEntity.formSaMkt?.remark,
            fileInfo: FileUploadUtility.parse(viewEntity.formSaMkt?.fileName, viewEntity.formSaMkt?.filePath),
          })
          if (viewEntity.formSaMkt.activityStartDate && viewEntity.formSaMkt.activityEndDate) {
            setFormSaMktDate({
              activityStartDate: moment(viewEntity.formSaMkt?.activityStartDate).toDate(),
              activityEndDate: moment(viewEntity.formSaMkt.activityEndDate).toDate()
            });
          }
        }
        setEntity(viewEntity);
        if (viewEntity.bohqId) {
          BOHQ.get(viewEntity.bohqId).then(res => {
            formRef.current?.setFieldsValue({
              bohqId: {value: res?.data?.bohqId, label: res?.data?.bohqName}
            })
          })
        }

        if (viewEntity.formSaMkt?.formSaMktId) {
          FormSaMktDetail.getsEx(viewEntity.formSaMkt?.formSaMktId).then((response) => {
            setDataSource(DataStore.init(response.data));
            FormSaMktAllocateMonth.gets(viewEntity.formSaMkt?.formSaMktId || 0).then((responseAllocateMonth) => {
              setFormSaMktAllocateMonths(addAllocateAmount(responseAllocateMonth.data, response.data, 'shareRate'));
            });
            FormSaMktAllocateCc.gets(viewEntity.formSaMkt?.formSaMktId || 0).then(res => {
              setFormSaMktAllocateCcs(addAllocateAmount(res.data, response.data, 'shareRate'));
            });
          });
        } else {
          setDataSource(DataStore.init([]));
          setFormSaMktAllocateMonths(DataStore.init([]));
          setFormSaMktAllocateCcs(DataStore.init([]));
        }
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = "活动申请";
      if (entity.formSaMkt) {
        title += '【编辑】'
      }
      props.setPageTitle(title);
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <SaMktWarningInfoApp {...warningSettings} />
      <ProForm
        formRef={formRef}
        submitter={{
          render: () => {
            return (
              <ApplyFooter
                viewEntity={entity}
                setLoading={props.setLoading}
                submitBackUrl="/mkt/sa/myactivity"
                doSubmit={async (type: number, forceSubmit: boolean) => {
                  if (!entity || !dataSource) {
                    return;
                  }
                  const remark = await editorRef?.current?.getHtml?.();
                  const values = await formRef.current?.validateFieldsReturnFormatValue?.();
                  if (values && values.errorFields && values.errorFields.length) {
                    return;
                  }
                  const statusId = type === ApplyFooterType.Draft ? Enum.FormStatus.DRAFT : Enum.FormStatus.AWAITING;
                  values.remark = remark;
                  const req = getPageResult(values, entity, statusId, dataSource, formSaMktAllocateMonths, formSaMktAllocateCcs);
                  if (req.code !== ResponseStatus.SUCCESS) {
                    message.error(req.message);
                    return;
                  }
                  props?.setLoading?.(true);
                  if (type === ApplyFooterType.Validate) {
                    return await FormSaMkt.Buttons.validate(req.data);
                  } else {
                    return await FormSaMkt.Buttons.apply({
                      forceSubmit: forceSubmit,
                      ...req.data
                    });
                  }
                }}
                del={async () => {
                  if (!entity || !entity.formId) {
                    return;
                  }
                  return await FormSaMkt.Buttons.del(entity.formId);
                }}
                showWarning={(result: WdiModalAppResult, submitCallback: any) => {
                  setWarningSettings({
                    visible: true,
                    title: "警示信息",
                    wdiPanelList: result.data,
                    onClose: () => {
                      setWarningSettings({visible: false});
                    },
                    onSave: async () => {
                      return await submitCallback();
                    },
                  });
                }}
              />
            )
          }
        }}
      >
        <WdiPanel title={<WdiCardTitle title='活动基本信息'/>}>
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={8}>
              <Form.Item name="activityName" label="活动名称" rules={[{required: true, message: '活动名称不能为空!'}]}>
                <Input/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item name="activityDate" label="活动期间" rules={[{required: true, message: '活动期间不能为空!'}]}>
                <RangePicker onChange={(values) => {
                  const dateRange = {
                    activityStartDate: '',
                    activityEndDate: ''
                  };
                  if (values && values.length === 2) {
                    formRef.current?.setFieldsValue({supplyDate: values});
                    dateRange.activityStartDate = moment(values[0]).format("YYYY-MM-DD");
                    dateRange.activityEndDate = moment(values[1]).format("YYYY-MM-DD");
                  }
                  setFormSaMktDate(Object.assign({}, formSaMktDate, dateRange));
                }}/>
              </Form.Item>
            </Col>
            {/*            <Col className="gutter-row" span={4}>
              <Form.Item name="oaFormNo" label="OA方案号">
                <Input/>
              </Form.Item>
            </Col>*/}
            <Col className="gutter-row" span={8}>
              <Form.Item name="bohqId" label="预算归属">
                <WdiSelect {...{
                  placeholder: "请选择预算归属",
                  showSearch: true,
                  disabled: true,
                  dataLoading: async (params) => {
                    const response = await BOHQ.searchMkt(Object.assign({
                      withPermissions: true,
                      isActive: true,
                    }, params));
                    return response.data.map((item) => {
                      return {value: item.bohqId, label: item.bohqName};
                    });
                  }
                }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 24]}>
            <Col className="gutter-row" span={16}>
              <Form.Item name="remark" label="方案简述" rules={[{required: true, message: '方案简述不能为空!'}]}>
                <WdiEditor setRef={setEditorRef}/>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={8}>
              <Form.Item
                name="fileInfo"
                label="附件"
                valuePropName='fileList'
                getValueFromEvent={(e: any) => {
                  return e.fileList || [];
                }}
              >
                <WdiFileUpload leftTopInfo="请选择文件并上传(单个文件不能超500M)"/>
              </Form.Item>
            </Col>
          </Row>
        </WdiPanel>
        <FormSaMktDetailsForApplyPanel
          form={entity?.form}
          dataSource={dataSource}
          onChange={onDetailsChange}
        />
        <FormSaMktDetailAllocateMonthApp
          activityStartDate={formSaMktDate?.activityStartDate}
          activityEndDate={formSaMktDate?.activityEndDate}
          onChange={(allocateMonths) => {
            setFormSaMktAllocateMonths(allocateMonths);
          }}
          detailDataSource={dataSource}
          dataSource={formSaMktAllocateMonths}/>
        <FormSaMktDetailAllocateCcApp
          dataSource={formSaMktAllocateCcs}
          detailDataSource={dataSource}
          onChange={(allocateCc) => {
            setFormSaMktAllocateCcs(allocateCc)
          }}
        />
      </ProForm>
    </>
  );
};
export default MktApplyApp;
